import classNames from 'classnames';

import Divider from 'components/shared/others/divider/divider';

import {
  BAR_MAX_HEIGHT,
  VALUE_LABEL_SPACE,
} from 'containers/user/goals/goals-monitoring/monitoring-chart/components/constants';
import { pluralizeMetric } from 'containers/user/goals/goals-monitoring/monitoring-chart/components/metric-block.helpers';

interface PlaceholderBlockProps {
  metricKey: string;
  previousYear?: string | number;
  currentYear?: string | number;
}

interface ColumnArgs {
  height: number;
  label?: string | number;
  colorClass: string;
}

const PlaceholderBlock = ({
  metricKey,
  previousYear,
  currentYear,
}: PlaceholderBlockProps): React.JSX.Element => {
  const rawMetricType = metricKey.replace(/([A-Z])/g, ' $1').trim();
  const metricType = pluralizeMetric(rawMetricType);

  const renderColumn = ({
    height,
    colorClass,
  }: ColumnArgs): React.JSX.Element => (
    <div className="text-center flex flex-col justify-end px-2.5 w-full">
      <div
        style={{ height: `${BAR_MAX_HEIGHT + VALUE_LABEL_SPACE}px` }}
        className="relative w-full overflow-hidden"
      >
        <div
          className={classNames(
            `transition-all duration-700 ease-out absolute bottom-0 left-0 right-0`,
            colorClass,
          )}
          style={{
            height: `${height}px`,
          }}
        />
      </div>
      <div className="h-3 w-10 bg-navy-100 rounded-sm mx-auto mt-1" />
    </div>
  );

  const renderChangeRow = (
    width: number,
    colorClass: string,
  ): React.JSX.Element => (
    <div className="flex items-baseline justify-between gap-2 min-w-0">
      <div
        className={classNames('h-3', colorClass)}
        style={{ width: `${width}px` }}
      />
      <div className={classNames(`h-3 w-8`, colorClass)} />
    </div>
  );

  return (
    <div className="text-center">
      <div className="text-center font-semibold text-gray-700 mb-2 capitalize px-2.5">
        {metricType}
      </div>

      <div className="flex justify-between items-end">
        {renderColumn({
          height: 65,
          label: previousYear,
          colorClass: 'bg-navy-200',
        })}
        {renderColumn({
          height: 85,
          label: currentYear,
          colorClass: 'bg-navy-100',
        })}
      </div>

      <Divider customClass="my-2" />
      <div className="mt-4 text-xs text-left text-gray-500 font-normal flex flex-col gap-1 px-2.5">
        {renderChangeRow(96, 'bg-navy-100')}
        {renderChangeRow(48, 'bg-navy-100')}
      </div>
    </div>
  );
};

export default PlaceholderBlock;
